import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/services/api';

/** Cache de dados do servidor (React Query). Não repete em erros 4xx (exceto 408/429). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => {
        if (err instanceof ApiError && err.status >= 400 && err.status < 500 && ![408, 429].includes(err.status)) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
